export default __webpack_public_path__ + "static/favicon-601e3a264d09399169b0d95d51118a74.ico";